import { BrowserRouter, Switch, Route } from "react-router-dom";
import RoutingComponent from "../common/RoutingComponent";

export default class LoaderPage extends RoutingComponent {
  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.login = props.login;
    // @ts-ignore
    this.main = props.main;
    // @ts-ignore
    this.loginProps = props.loginProps;
    // @ts-ignore
    this.mainProps = props.mainProps;
  }

  render() {
    let isAuthenticated = this.appSetting.localStorageValue.isAuthenticated.get();
    if (isAuthenticated === "true") {
      return this.authenticatedRoute;
    }

    return this.unauthenticatedRoute;
  }

  get authenticatedRoute() {
    // @ts-ignore
    return <this.main></this.main>;
  }

  get unauthenticatedRoute() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/">
            {/* @ts-ignore */}
            <this.login
              redirectUrl={
                window.location.href.toLowerCase().indexOf("/login") > -1
                  ? // @ts-ignore
                    this.loginProps
                  : window.location.href
              }
            />
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }
}
